import { memo } from 'react';
import MathText from './MathText';
import { stripHtml } from './formatConfig';

/**
 * Texte qui peut porter des formules `$…$` : rendu par MathText seulement
 * s'il en contient. Sans formule, le texte reste tel quel (MathText espace
 * aussi les milliers : « Attendu 1217 » deviendrait « Attendu 1 217 »).
 */
export const TexteFormules = memo(({ children, className = '' }) => (
  typeof children === 'string' && children.includes('$')
    ? <MathText className={className}>{children}</MathText>
    : <span className={className}>{children}</span>
));
TexteFormules.displayName = 'TexteFormules';

/**
 * Énoncé d'un exercice sur une ligne de liste (panier, colonnes des groupes) :
 * texte entier coupé en CSS après le rendu (une coupe en caractères pourrait
 * laisser un « $ » seul), avec un peu de marge pour qu'une fraction ne soit
 * pas rognée ; l'œil de la ligne donne l'aperçu entier. Pour un nom
 * accessible, `apercuTexte` donne le texte simple.
 */
const ApercuExercice = ({ payload, className = '' }) => {
  const texte = stripHtml(payload?.texte) || 'Exercice';
  return (
    <span className={`block min-w-0 ${className}`}>
      <TexteFormules className="block truncate py-0.5">{texte}</TexteFormules>
    </span>
  );
};

export default ApercuExercice;
